import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import clsx from 'clsx';
import { UserBox } from '@/components/modules/Image/UserBox';
export const UserBoxList = (props) => {
    const { avatarSize = 'md', className = '', isNestedLink, items } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex flex-col gap-y-20', className) }, { children: items.map((item) => (_createElement(UserBox, Object.assign({}, item, { avatarSize: avatarSize, isNestedLink: isNestedLink, key: item.id })))) })));
};
